import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import Heading from '../../components/Heading';
import AnnouncementsTable from '../../components/AnnouncementsTable';
import Tabs from '../../components/Tabs';
import WithNavigation from '../../layouts/WithNavigation';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { setSearch, clearSearch } from '../../store/actions/search';
import { upload } from '../../helpers/upLoadHelper'
import Loader from '../../components/Loader';
import { selectPRLoader } from '../../store/selectors/PropertyLoader';
import { fetchAnnouncements, saveAnnouncement, deleteAnnouncement } from '../../store/actions/Announcements';
import { selectAnnouncements } from '../../store/selectors/Announcements';
import { getTenantName } from '../../helpers/validationHelper';
import { stopLoaders } from '../../store/actions/loader';

class Announcements extends Component {
  componentDidMount() {
    const { onFetchAnnouncements, clearSearch, user, stopLoaders } = this.props;
    stopLoaders();
    clearSearch();
    // if(user && (user.roles[0].role.name === 'Admin' || user.roles[0].role.name === 'Property Developer'  )) {
      onFetchAnnouncements(user.id,user.roles[0].role.name)
    // }

  }
  saveAnnouncement = async (data) => {
    const tenantName = getTenantName();
    let params = {};
    let imageUrl = []
    if (data.attachments && data.attachments.length > 0) {
      await this.handleMultipleUpload(data.attachments, function (resObj) {
        imageUrl = resObj
      })
    }
    params = {
      'title': data.title,
      'description': data.description,
      'userId': this.props.user.id,
      'propertyId': data.propertyId,
      'attachments': imageUrl && imageUrl.length > 0 ? JSON.stringify(imageUrl) : "",
      "IsBuilding":data.IsBuilding,
      "IsLevel":data.IsLevel,
      "AnnouncementBuildingLevels": data.AnnouncementBuildingLevels,
      'AnnouncementSuites': data.AnnouncementSuites,
      'tenant': tenantName
    }   
    this.props.onSaveAnnouncement(params)
  }

  handleMultipleUpload = async (selectedImage, callback) => {
    let uploadImages = [];
    for (let i = 0; i < selectedImage.length; i++) {
      if(selectedImage[i] && selectedImage[i].id) {
        uploadImages.push(selectedImage[i])
      } else {
      await this.uploadimg(selectedImage[i], (imgData) => {
        uploadImages.push(imgData);
      });
    }
    }
    callback(uploadImages)
  }
  uploadimg = async (imgFile, callback) => {
    let imageUrl = await upload(imgFile)
    let object = {
      title: imageUrl.split('.com/')[1],
      url: imageUrl
    }
    callback(object);
  }
  onDeleteAnnouncement(data) {
   this.props.onDeleteAnnouncement(data.id)
  }

  render() {
    const { announcements, onFetchProperties, setSearch, loader } = this.props;
    
    return (
     <>
      {
         loader ?
          <Loader center={true}/>
          :(null)
      }
      <WithNavigation
        title="Announcements"
        top={(
          <Heading
            headline="Announcements"
            items={[
              {
                key: 'Announcements',
                value: announcements.length,
              }
            ]}
          />
        )}
        bottom={
          // loader ?
          // <Loader center={true}/>
          // :
          (
          <Tabs
            items={[
              {
                label: 'Announcements',
                length: announcements.length,
                content: (
                  <AnnouncementsTable
                    announcements={announcements}
                    onFetchProperties={onFetchProperties}
                    onSaveAnnouncements={ (data) => this.saveAnnouncement(data)}
                    onSearch={e => setSearch({ announcements: e.target.value.trim() })}
                    onDeleteAnnouncement={ (data) => this.onDeleteAnnouncement(data)}
                  />
                ),
              } 
            ]}
          />
        )}
      />
     </>
    );
  }
}

const mapStateToProps = state => ({
  announcements: selectAnnouncements(state),
  user: selectAuthenticatedUser(state),
  loader: selectPRLoader(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({
  onFetchAnnouncements: fetchAnnouncements,
  onSaveAnnouncement: saveAnnouncement,
  onDeleteAnnouncement: deleteAnnouncement,
  setSearch,
  clearSearch,
  stopLoaders
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Announcements);
